import * as React from "react"

function Email(props) {
  return (
    <svg
      viewBox="0 0 46 46"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={203.698}
        cy={125.424}
        r={70.298}
        fill="#e5eeff"
        transform="matrix(.3259 0 0 .3259 -43.474 -17.965)"
      />
      <path
        d="M12.113 34.933h21.593a2.558 2.558 0 002.553-2.554V18.681a.715.715 0 00-.26-.551l-3.57-3.018V9.83c0-1.132-.9-2.032-2.032-2.032h-14.83c-1.132 0-2.031.9-2.031 2.032v5.166L9.82 18.13a.715.715 0 00-.261.551V32.38a2.54 2.54 0 002.553 2.554zm21.593-1.45H12.113c-.609 0-1.102-.494-1.102-1.104V20.074l8.27 5.863-5.862 4.469c-.319.232-.377.697-.145 1.016.233.319.697.377 1.016.145l6.24-4.789 2.031 1.451c.261.175.58.175.842 0l2.031-1.45 6.24 4.759c.32.232.784.174 1.016-.145.232-.32.174-.784-.145-1.016l-5.863-4.47 8.126-5.746V32.38c0 .61-.493 1.103-1.102 1.103zm.696-14.802l-1.973 1.393v-3.076l1.973 1.683zM15.567 9.278h14.83c.32 0 .58.261.58.58V21.09l-8.01 5.66-7.98-5.66V9.83c0-.29.26-.552.58-.552zm-2.031 10.796l-2.061-1.45 2.06-1.742v3.192zm9.373 2.96h.175c.406 0 .725-.319.725-.725a.718.718 0 00-.725-.726h-.175a4.608 4.608 0 01-4.614-4.614 4.608 4.608 0 014.614-4.614 4.608 4.608 0 014.615 4.614v1.219a.815.815 0 01-1.625 0V16.94a3.054 3.054 0 00-2.99-3.047c-1.654-.03-3.018 1.335-3.047 2.989-.029 1.654 1.364 3.047 3.018 3.076.668 0 1.335-.232 1.887-.638.61 1.103 1.973 1.48 3.076.87a2.27 2.27 0 001.161-2.002V16.94a6.063 6.063 0 00-6.065-6.066c-3.338 0-6.066 2.729-6.066 6.066a6.026 6.026 0 006.036 6.095zm0-4.527a1.56 1.56 0 01-1.567-1.567c0-.87.697-1.567 1.567-1.567.871 0 1.568.696 1.568 1.567a1.56 1.56 0 01-1.568 1.567z"
        fill="#052879"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default Email
